import React from 'react';
import PropTypes from 'prop-types';

import { Legend, Color } from './styles';

const StorePriceLegend = ({ prices, colors }) => (
  <Legend>
    {prices.map(price => (
      <div key={price.id}>
        <Color style={{ backgroundColor: colors[price.id] }} />
        {price.store.name} <small>{price.name}</small>
      </div>
    ))}
  </Legend>
);

StorePriceLegend.defaultProps = {
  colors: {},
};

StorePriceLegend.propTypes = {
  colors: PropTypes.object,
  prices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      store: PropTypes.shape({
        name: PropTypes.string,
      }),
    })
  ).isRequired,
};

export default StorePriceLegend;
